export class LoginPopupError extends Error {
  public name: string;

  constructor(message: string) {
    super(message);

    this.name = 'LoginPopupError';

    Object.setPrototypeOf(this, LoginPopupError.prototype);
  }
}
